import * as React from "react";
import { Flex, HStack, Skeleton, VStack } from "@chakra-ui/react";
import { Tabs, Wrapper, BackButton } from "components";
import { useCurrentCase, useWindowSize } from "duck";
import { Actions, Avatar, CaseName, Info } from "./components";
import { EmergencyDrugs } from "./components/actions/components";
import { hooks, utils } from "./duck";

interface HeaderProps {
  allTabs: boolean;
  hasDentalCharting: boolean;
  hasTplo: boolean;
}

const Header: React.FC<HeaderProps> = ({
  allTabs,
  hasDentalCharting,
  hasTplo
}) => {
  const { width } = useWindowSize();

  const { name, disclaimerProcedure, patient, createdFrom } = useCurrentCase(
    ({ data }) => ({
      name: data.name,
      createdFrom: data.createdFrom,
      patient: data.client.patient,
      disclaimerProcedure:
        data.disclaimerProcedures.find(procedure => procedure.selected) || null
    })
  );

  const { headerHidden } = hooks.useScrollDirection(!!createdFrom);

  return (
    <Wrapper
      as={HStack}
      alignItems="flex-start"
      position="sticky"
      zIndex={4}
      p="32px"
      top={createdFrom ? "-226px" : "-205px"}
      paddingBottom={headerHidden ? "24px" : "32px"}
    >
      <VStack alignItems="left" spacing={6} width="100%">
        <HStack spacing="4">
          <BackButton />

          {name ? (
            <CaseName name={name} createdFrom={createdFrom || null} />
          ) : (
            <Skeleton width="150px" height="32px" borderRadius="4px" />
          )}
        </HStack>

        <Avatar patient={patient} disclaimerProcedure={disclaimerProcedure} />

        <Flex align="start" flex={1} justify="space-between">
          <Flex direction="column" gap={3}>
            {headerHidden && (
              <Info
                patient={patient}
                disclaimerProcedure={disclaimerProcedure}
              />
            )}
            <Tabs tabs={utils.getTabs(allTabs, hasDentalCharting, hasTplo)} />
          </Flex>
          {headerHidden ? <EmergencyDrugs iconOnly={width < 1475} /> : null}
        </Flex>
      </VStack>

      {!headerHidden && <Actions position="absolute" right="32px" top="36px" />}
    </Wrapper>
  );
};

export default Header;
